import React, { useEffect, useState } from "react";
import TableContainer from "Common/TableContainer";
import { getTransactionsList } from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useLoader } from "../../context/LoaderContext";

const TransactionList = () => {
    const [transactions, setTransactions] = useState([]);
    const { showLoader, hideLoader } = useLoader();


    useEffect(() => {
        const fetchData = async () => {
            showLoader();

            try {
                const params = {
                    page: 0,
                    size: 1000,
                    sort: "transactionId,desc"
                };


                const response = await getTransactionsList(params);
                const transactionsData = response.data?._embedded?.transactions || [];
                setTransactions(transactionsData);
            } catch (error) {
                toast.error("Error fetching transactions: " + error, { autoClose: 2000 });
            } finally {
                hideLoader();
            }
        };
        fetchData();
    }, []);

    const columns = [
        {
            header: "UUID",
            accessorKey: "uuid",
            enableColumnFilter: false,
            enableSorting: false,
        },
        // TODO: Ver si se pueden mapear modelos de relaciones, ejemplo esta de Wallet
        {
            header: "Wallet",
            accessorKey: "wallet.name",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Tipo",
            accessorKey: "typeTransaction",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Monto",
            accessorKey: "amount",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Fecha",
            accessorKey: "createdAt",
            enableColumnFilter: false,
            enableSorting: true,
        }
    ];


    return (
        <div className="card">
            <div className="card-body">
                <TableContainer
                    isPagination={true}
                    isSelect={true}
                    isGlobalFilter={true}
                    columns={columns}
                    data={transactions}
                    customPageSize={5}
                    divclassName="my-2 col-span-12 overflow-x-auto lg:col-span-12"
                    tableclassName="hover group dataTable w-full text-sm align-middle whitespace-nowrap no-footer"
                    theadclassName="border-b border-slate-200 dark:border-zink-500"
                    trclassName="group-[.stripe]:even:bg-slate-50 group-[.stripe]:dark:even:bg-zink-600 transition-all duration-150 ease-linear group-[.hover]:hover:bg-slate-50 dark:group-[.hover]:hover:bg-zink-600 [&.selected]:bg-custom-500 dark:[&.selected]:bg-custom-500 [&.selected]:text-custom-50 dark:[&.selected]:text-custom-50"
                    thclassName="p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500 sorting px-3 py-4 text-slate-900 bg-slate-200/50 font-semibold text-left dark:text-zink-50 dark:bg-zink-600 dark:group-[.bordered]:border-zink-500"
                    tdclassName="p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500"
                    PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
                />
            </div>

        </div>
    );
};

export default TransactionList;
